import React from 'react';

export default function CircleClose(props) {
  return (
    <svg width={props.size} height={props.size} viewBox="9 9 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8571 25.7143C19.9579 25.7143 25.7143 19.9579 25.7143 12.8571C25.7143 5.75634 19.9579 0 12.8571 0C5.75634 0 0 5.75634 0 12.8571C0 19.9579 5.75634 25.7143 12.8571 25.7143Z"
        transform="translate(10.8173 29) rotate(-45)"
        fill={props.primaryColor}
        fillOpacity="0.4"
      />
      <path
        d="M12.8571 26.7143C20.5102 26.7143 26.7143 20.5102 26.7143 12.8571C26.7143 5.20405 20.5102 -1 12.8571 -1C5.20405 -1 -1 5.20405 -1 12.8571C-1 20.5102 5.20405 26.7143 12.8571 26.7143Z"
        transform="translate(10.8173 29) rotate(-45)"
        stroke={props.secondaryColor}
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.41661L10 4.58329L5.41666 4.58327V2.15792e-05L4.58333 0L4.58335 4.58327L2.15792e-05 4.58327L0 5.41663H4.58333L4.58335 9.99999H5.41666L5.41663 5.41663L10 5.41661Z"
        transform="translate(21.9289 29) rotate(-45)"
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
      />
    </svg>
  );
}

CircleClose.defaultProps = {
  size: 40,
  primaryColor: 'white',
  secondaryColor: '#A0A0A0',
};